import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddVehiclesService {

  constructor(private http:HttpClient) { }

  addVehicle(data:any){
    return this.http.post(environment.apiUrl + "vehicles/addNew" , data)
  }

  addVehicleCSV(data:any){
    return this.http.post(environment.apiUrl + "vehicles/addNewCSV" , data)
  }

  checkVerifyCity(data:any){
    return this.http.post(environment.apiUrl1 + "city/verify"  , data)
  }

  getAllRanges(){
    return this.http.get(environment.apiUrl + "range/get/all")
  }

  addImage(file:any){
    const formData = new FormData(); 
    formData.append("files", file);
    return this.http.post( environment.filePath, formData )
  }



}
